import {createRoot} from "react-dom/client";

document.addEventListener('click', (event) => {
    const dataToggle = event.target.getAttribute('data-toggle')
    if (dataToggle) {
        document.getElementById(dataToggle)?.classList.toggle("active");
    }

    let dataToggleNested = event.target.closest('[data-toggle-nested]')
    if (dataToggleNested !== null) {
        dataToggleNested = dataToggleNested.getAttribute('data-toggle-nested')
        document.getElementById(dataToggleNested)?.classList.toggle("active");
    }

    const dataTabsItem = event.target.closest('[data-tabs-item]')
    if (dataTabsItem !== null) {
        const index = Array.prototype.indexOf.call(dataTabsItem.parentElement.children, dataTabsItem);
        const tabs = dataTabsItem.closest('[data-tabs]');
        if (tabs) {
            tabs.setAttribute('data-tabs', index + 1)
        }
    }

    function openNav(identifier) {
        console.log("openNav", identifier)
        document.querySelectorAll('[data-nav-item]').forEach((el) => {
            el.classList.remove('active')
            el.classList.remove('parent')
        })
        document.querySelector('[data-nav-item="' + identifier + '"]')?.classList.add('active')
        document.querySelector('[data-nav-item="' + identifier + '"]').parentElement.closest('[data-nav-item]')?.classList.add('parent')
        document.querySelector('[data-nav-item="' + identifier + '"]').parentElement.closest('[data-nav-item]')?.parentElement.closest('[data-nav-item]')?.classList.add('parent')
    }

    let dataNavOpen = event.target.closest('[data-nav-open]')
    if (dataNavOpen !== null) {
        openNav(dataNavOpen.getAttribute('data-nav-open'))
    }

    let dataNavOpenActiveOrInactive = event.target.closest('[data-nav-open-active][data-nav-open-inactive]')
    if (dataNavOpenActiveOrInactive !== null) {
        const item = dataNavOpenActiveOrInactive.closest('[data-nav-item]')
        if (item) {
            if (item.classList.contains('active')) {
                openNav(dataNavOpenActiveOrInactive.getAttribute('data-nav-open-active'))
            } else {
                openNav(dataNavOpenActiveOrInactive.getAttribute('data-nav-open-inactive'))
            }
        }
    }
});

import '../../../NodeTypes/Block/HaconWebApp/HaconWebApp';
import '../../../NodeTypes/Block/LinkSlider/LinkSlider';
import "../../../NodeTypes/Block/Marquee/Marquee";
import '../../../NodeTypes/Content/CountingNumber/CountingNumber';
import '../../../NodeTypes/Content/JobsWidget/JobsWidget';
import "../../../NodeTypes/Document/JobDetail/JobDetail";

import {
    openContactModal,
    openEnquiryModal,
    openAppointmentModal,
    openNewsletterModal,
    openNewsletterResponseModal,
    openInterestedPartyModal,
    openPressServiceModal,
    openNewsletterUnsubscribeModal,
    openNewsletterUnsubscribeConfirmModal,
    openPressServiceUnsubscribeModal,
    openPressServiceUnsubscribeConfirmModal,
    openNewsletterSubscribeConfirmModal,
    openPressServiceSubscribeConfirmModal,
    openChooserFormModal,

} from "@nt/kombiverkehr-react-prime";
import "@nt/kombiverkehr-react-prime/style.css";

window.openContactModal = () => {
    openContactModal("/api/contact-form")
}

window.openEnquiryModal = () => {
    openEnquiryModal("/api/enquiry-form")
}

window.openAppointmentModal = () => {
    openAppointmentModal("/api/appointment-form")
}

window.openInterestedPartyModal = () => {
    openInterestedPartyModal("/api/interested-party-form")
}

window.openNewsletterModal = () => {
    openNewsletterModal("/api/subscription")
}

window.openPressServiceModal = () => {
    openPressServiceModal("/api/press-service-subscription")
}
window.openChooserFormModal = () => {
    openChooserFormModal("/api/contact-form", "/api/enquiry-form", "/api/appointment-form");
}

function onDomReady() {
    // The parameter 'isSuccess' accepts true if a success message needs to be shown
    // false if a failure message needs to be shown
    const urlParams = new URLSearchParams(window.location.search);
    const settingFor = urlParams.has('newsletter') ? 'newsletter' : 'press-service';
    if ((urlParams.has('newsletter') || urlParams.has('press-service')) && (urlParams.get('newsletter') === 'success' || urlParams.get('press-service') === 'success')) {
        openNewsletterResponseModal(true, settingFor);
    } else if ((urlParams.has('newsletter') || urlParams.has('press-service')) && (urlParams.get('newsletter') === 'failure' || urlParams.get('press-service') === 'failure')) {
        openNewsletterResponseModal(false, settingFor);
    }


    if (urlParams.has('unsubscribe') && (urlParams.get('unsubscribe') === 'newsletter' || urlParams.get('unsubscribe') === 'press-service')) {
        let email = urlParams.has('email') ? urlParams.get('email') : '';
        if (urlParams.get('unsubscribe') === 'newsletter') {
            openNewsletterUnsubscribeModal("/api/newsletter-unsubscribe", email);
        } else if (urlParams.get('unsubscribe') === 'press-service') {
            openPressServiceUnsubscribeModal("/api/press-service-unsubscribe", email);
        }
    }

    if (urlParams.has('unsubscribe-confirm') && (urlParams.get('unsubscribe-confirm') === 'newsletter' || urlParams.get('unsubscribe-confirm') === 'press-service')) {
        let token = urlParams.has('token') ? urlParams.get('token') : '';
        if (urlParams.get('unsubscribe-confirm') === 'newsletter') {
            openNewsletterUnsubscribeConfirmModal("/api/confirm/newsletter-unsubscribe", token);
        } else if (urlParams.get('unsubscribe-confirm') === 'press-service') {
            openPressServiceUnsubscribeConfirmModal("/api/confirm/press-service-unsubscribe", token);
        }
    }


    if (urlParams.has('subscribe-confirm') && (urlParams.get('subscribe-confirm') === 'newsletter' || urlParams.get('subscribe-confirm') === 'press-service')) {
        let token = urlParams.has('token') ? urlParams.get('token') : '';
        if (urlParams.get('subscribe-confirm') === 'newsletter') {
            openNewsletterSubscribeConfirmModal("/api/subscription-validate", token);
        } else if (urlParams.get('subscribe-confirm') === 'press-service') {
            openPressServiceSubscribeConfirmModal("/api/press-service-validate", token);
        }
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDomReady);
} else {
    onDomReady();
}
